import { Pipe, PipeTransform } from '@angular/core';
import { UserData } from "../../providers/user";
import { IUserStats } from '../../shared/models/user.model';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'userStats',
})
export class UserStatsPipe implements PipeTransform {

  constructor(
    private userData: UserData
  ) { }

  transform(idClient: string, idUser: string): Observable<IUserStats> {
    return this.userData.getUserStatsPointsByUserId(idClient,idUser);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/user-stats/user-stats.ts